module.exports = __webpack_public_path__ + "static/media/lp3.9f03c6c0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lp3.webp
// module id = 680
// module chunks = 31